
//** REST Fetch Abstraction (to decouple dependency on axios) */
export interface IHttpRequest {
	get<T = any>(url: string, config?: any): Promise<T>;
	delete(url: string, config?: any): Promise<any>;
	post<T = any>(url: string, data?: any, config?: any): Promise<T>;
	put<T = any>(url: string, data?: any, config?: any): Promise<T>;
}

/** Set Browser Cookie */
export const setCookie = (name, value, days) => {
	let expires = "";
	if (days) {
		const date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

/* Promise with time delay */
export const delay = (ms) => {
	return new Promise(resolve => setTimeout(() => resolve(), ms));
}



// WEBPACK FOOTER //
// ./src/application/utils.ts